module.exports = __webpack_public_path__ + "img/arqu-cabc-03.af8ba709.jpg";